<div class="page-header">
  <div class="modal-toolbar">
    <div class="page-title">{{ title }}</div>
    <div class="header-buttons">
      <button type="button" class="menu-button" aria-label="Open menu">
        <app-display-icon [icon]="icons.menu"></app-display-icon>
      </button>
    </div>
  </div>
</div>
